module.exports = __webpack_public_path__ + "img/hand-point-right-solid.d1ab550.svg";